// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"Forms_FormTitle__3WN3i","FormGroup":"Forms_FormGroup__2D6hf","FormControl":"Forms_FormControl__2DC_R"};